import React from 'react';
import './OKRSection.css';


const levels = [
    {
        id: 'company',
        cadence: 'Annual',
        title: 'Company',
        color: '#010A59',
        textColor: '#ffffff',
        badgeColor: '#CED9FE',
        badgeText: '#010A59',
        desc: 'Set once a year by leadership. Defines the strategic direction for Tripletex as a whole — the big bets that everything else should point back to.',
    },
    {
        id: 'department',
        cadence: 'Quarterly',
        title: 'Department',
        color: '#0A41FA',
        textColor: '#ffffff',
        badgeColor: '#CED9FE',
        badgeText: '#010A59',
        desc: 'Set each quarter by department leads together with their teams. Translates company direction into concrete focus areas — what this area will do to move the needle.',
    },
    {
        id: 'individual',
        cadence: 'Quarterly',
        title: 'Individual',
        color: '#F9E6B5',
        textColor: '#010A59',
        badgeColor: '#010A59',
        badgeText: '#F9E6B5',
        desc: 'Set each quarter together with your manager. Connects personal growth and contributions to the team and company direction. A tool for focus — not a performance review checklist.',
    },
];

function OKRSection() {
    return (
        <div className="container">
            <div className="okr-section">

                <div className="okr-intro">
                    <h1 className="okr-title">OKR & Outcomes</h1>
                    <p className="okr-lead">
                        An <strong>Objective</strong> is where we're going. <strong>Key Results</strong> are
                        how we know we got there. We use OKRs at three levels — cascading from company
                        strategy down to individual focus.
                    </p>
                </div>

                <div className="okr-cascade">
                    {levels.map((level, idx) => (
                        <React.Fragment key={level.id}>
                            <div className="okr-card" style={{ background: level.color }}>
                                <span
                                    className="okr-badge"
                                    style={{ background: level.badgeColor, color: level.badgeText }}
                                >
                                    {level.cadence}
                                </span>
                                <h3 className="okr-card__title" style={{ color: level.textColor }}>
                                    {level.title}
                                </h3>
                                <p className="okr-card__desc" style={{ color: level.textColor }}>
                                    {level.desc}
                                </p>
                            </div>
                            {idx < levels.length - 1 && (
                                <div className="okr-arrow" aria-hidden="true">↓</div>
                            )}
                        </React.Fragment>
                    ))}
                </div>

            </div>
        </div>
    );
}

export default OKRSection;
